class Role {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }
}

const Roles = {
  ACCESS: new Role(0, 'access'),
  ADMIN: new Role(1, 'admin'),
  RECAMBISTA: new Role(2, 'recambista'),
  COMERCIAL: new Role(3, 'comercial'),
  FINANZAS: new Role(4, 'finanzas'),
  INCIDENCIAS: new Role(5, 'incidencias'),
  PROVEEDORES: new Role(6, 'proveedor'),
  INVERSOR: new Role(7, 'inversor')
};

// Utility functions
const getRoleById = (id) => Object.values(Roles).find(role => role.id === id);
const getRoleByName = (name) => Object.values(Roles).find(role => role.name === name);
const getAllRoles = () => Object.values(Roles).filter(role => role.id !== 0);
const getRolesExcluding = (id) => Object.values(Roles).filter(role => role.id !== id);

export {
  Role,
  Roles,
  getRoleById,
  getRoleByName,
  getAllRoles,
  getRolesExcluding
};
